<template>
  <div class="sidebar">
    <div class="sidebar-header">
      <div class="logo-area">
        <div class="logo-circle">
          <span class="logo-text">{{ currentModuleName }}</span>
        </div>
        <div class="company-info">
          <span class="company-name">{{ companyName }}</span>
        </div>
      </div>
    </div>
    
    <ul class="sidebar-menu">
      <li class="menu-item" :class="{ active: currentTab === 'dashboard' }">
        <button @click="$emit('navigate', 'dashboard')">
          <i class="fas fa-home"></i>
          <span>首页</span>
        </button>
      </li>
      
      <li class="menu-item has-submenu" :class="{ active: isUserCenterActive, open: userCenterOpen }">
        <button @click="toggleUserCenter">
          <i class="fas fa-users"></i>
          <span>用户中心</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="userCenterOpen">
          <li><button :class="{ active: currentTab === 'users' }" @click="$emit('navigate', 'users')">用户管理</button></li>
          <li><button :class="{ active: currentTab === 'roles' }" @click="$emit('navigate', 'roles')">角色管理</button></li>
          <li><button :class="{ active: currentTab === 'organizations' }" @click="$emit('navigate', 'organizations')">组织管理</button></li>
        </ul>
      </li>
      
      <li class="menu-item has-submenu" :class="{ active: isAnnouncementCenterActive, open: announcementCenterOpen }">
        <button @click="toggleAnnouncementCenter">
          <i class="fas fa-bullhorn"></i>
          <span>公告中心</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="announcementCenterOpen">
          <li><button :class="{ active: currentTab === 'announcements' }" @click="$emit('navigate', 'announcements')">公告管理</button></li>
        </ul>
      </li>
      
      <li class="menu-item has-submenu" :class="{ active: isPermissionCenterActive, open: permissionCenterOpen }">
        <button @click="togglePermissionCenter">
          <i class="fas fa-shield-alt"></i>
          <span>权限中心</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="permissionCenterOpen">
          <li><button :class="{ active: currentTab === 'aaPermissions' }" @click="$emit('navigate', 'aaPermissions')">公告权限</button></li>
          <li><button :class="{ active: currentTab === 'baPermissions' }" @click="$emit('navigate', 'baPermissions')">模块权限</button></li>
          <li><button :class="{ active: currentTab === 'laPermissions' }" @click="$emit('navigate', 'laPermissions')">流程权限</button></li>
          <li><button :class="{ active: currentTab === 'daPermissions' }" @click="$emit('navigate', 'daPermissions')">报表权限</button></li>
        </ul>
      </li>
      
      <li class="menu-item has-submenu" :class="{ active: isDataCenterActive, open: dataCenterOpen }">
        <button @click="toggleDataCenter">
          <i class="fas fa-database"></i>
          <span>数据中心</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="dataCenterOpen">
          <li><button :class="{ active: currentTab === 'databaseManager' }" @click="$emit('navigate', 'databaseManager')">数据库管理</button></li>
          <li><button :class="{ active: currentTab === 'sqlExecution' }" @click="$emit('navigate', 'sqlExecution')">语句执行</button></li>
          <li><button :class="{ active: currentTab === 'logQuery' }" @click="$emit('navigate', 'logQuery')">日志查询</button></li>
        </ul>
      </li>
      
      <li class="menu-item has-submenu" :class="{ active: isDevCenterActive, open: devCenterOpen }">
        <button @click="toggleDevCenter">
          <i class="fas fa-code"></i>
          <span>研发中心</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="devCenterOpen">
          <li><button :class="{ active: currentTab === 'processManagement' }" @click="$emit('navigate', 'processManagement')">流程管理</button></li>
          <li><button :class="{ active: currentTab === 'jobManagement' }" @click="$emit('navigate', 'jobManagement')">定时作业管理</button></li>
        </ul>
      </li>
      
      <li class="menu-item has-submenu" :class="{ active: isManagementCenterActive, open: managementCenterOpen }">
        <button @click="toggleManagementCenter">
          <i class="fas fa-cog"></i>
          <span>管理中心</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="managementCenterOpen">
          <li><button :class="{ active: currentTab === 'taskManagement' }" @click="$emit('navigate', 'taskManagement')">任务管理</button></li>
          <li><button :class="{ active: currentTab === 'moduleManagement' }" @click="$emit('navigate', 'moduleManagement')">模块管理</button></li>
          <li><button :class="{ active: currentTab === 'systemManagement' }" @click="$emit('navigate', 'systemManagement')">系统管理</button></li>
          <li><button :class="{ active: currentTab === 'companyManagement' }" @click="$emit('navigate', 'companyManagement')">公司管理</button></li>
          <li><button :class="{ active: currentTab === 'tenantManagement' }" @click="$emit('navigate', 'tenantManagement')">租户管理</button></li>
        </ul>
      </li>
      
      <li class="menu-item has-submenu" :class="{ active: isReportCenterActive, open: reportCenterOpen }">
        <button @click="toggleReportCenter">
          <i class="fas fa-chart-bar"></i>
          <span>报表中心</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="reportCenterOpen">
          <li><button :class="{ active: currentTab === 'reportManagement' }" @click="$emit('navigate', 'reportManagement')">报表管理</button></li>
          <li><button :class="{ active: currentTab === 'systemReports' }" @click="$emit('navigate', 'systemReports')">系统报表</button></li>
          <li><button :class="{ active: currentTab === 'customReports' }" @click="$emit('navigate', 'customReports')">自定义报表</button></li>
        </ul>
      </li>
      
      <li class="menu-item has-submenu" :class="{ active: isPersonalCenterActive, open: personalCenterOpen }">
        <button @click="togglePersonalCenter">
          <i class="fas fa-user"></i>
          <span>个人中心</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="personalCenterOpen">
          <li><button :class="{ active: currentTab === 'personalInfo' }" @click="$emit('navigate', 'personalInfo')">个人信息</button></li>
          <li><button :class="{ active: currentTab === 'passwordChange' }" @click="$emit('navigate', 'passwordChange')">密码修改</button></li>
          <li><button :class="{ active: currentTab === 'proxySettings' }" @click="$emit('navigate', 'proxySettings')">代理设置</button></li>
          <li><button :class="{ active: currentTab === 'quickLinkManager' }" @click="$emit('navigate', 'quickLinkManager')">快捷入口</button></li>
        </ul>
      </li>
      
      <li class="menu-item has-submenu" :class="{ active: isTodoCenterActive, open: todoCenterOpen }">
          <button @click="toggleTodoCenter">
            <i class="fas fa-tasks"></i>
            <span>待办中心</span>
            <i class="fas fa-angle-down arrow"></i>
          </button>
          <ul class="submenu" v-show="todoCenterOpen">
            <li><button :class="{ active: currentTab === 'pendingTasks' }" @click="$emit('navigate', 'pendingTasks')">待处理</button></li>
            <li><button :class="{ active: currentTab === 'launchableProcesses' }" @click="$emit('navigate', 'launchableProcesses')">可发起</button></li>
            <li><button :class="{ active: currentTab === 'drafts' }" @click="$emit('navigate', 'drafts')">草稿箱</button></li>
          </ul>
        </li>
      
      <li class="menu-item has-submenu" :class="{ active: isTaskCenterActive, open: taskCenterOpen }">
        <button @click="toggleTaskCenter">
          <i class="fas fa-list-alt"></i>
          <span>任务中心</span>
          <i class="fas fa-angle-down arrow"></i>
        </button>
        <ul class="submenu" v-show="taskCenterOpen">
          <li><button :class="{ active: currentTab === 'completedTasks' }" @click="$emit('navigate', 'completedTasks')">已处理任务</button></li>
          <li><button :class="{ active: currentTab === 'viewableTasks' }" @click="$emit('navigate', 'viewableTasks')">可查看任务</button></li>
          <li><button :class="{ active: currentTab === 'submittedTasks' }" @click="$emit('navigate', 'submittedTasks')">已提交任务</button></li>
          <li><button :class="{ active: currentTab === 'ccTasks' }" @click="$emit('navigate', 'ccTasks')">抄送任务</button></li>
        </ul>
      </li>
    </ul>
    
    <div class="sidebar-toggle" @click="toggleSidebar">
      <i class="fas fa-chevron-left"></i>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  currentTab: {
    type: String,
    default: 'dashboard'
  },
  currentModule: {
    type: String,
    default: 'bpm'
  }
})

defineEmits(['navigate'])

const companyName = ref('顾德智能')

const moduleNames = {
  bpm: 'BPM',
  hr: 'HR',
  erp: 'ERP',
  email: 'MAIL',
  message: 'MSG',
  schedule: 'SCH',
  crm: 'CRM',
  srm: 'SRM',
  ai: 'AI',
  app: 'APP',
  kanban: 'KB',
  mes: 'MES',
  wms: 'WMS',
  plm: 'PLM',
  doc: 'DOC'
}

const currentModuleName = computed(() => {
  return moduleNames[props.currentModule] || 'BPM'
})

const userCenterOpen = ref(false)
const announcementCenterOpen = ref(false)
const permissionCenterOpen = ref(false)
const dataCenterOpen = ref(false)
const devCenterOpen = ref(false)
const managementCenterOpen = ref(false)
const reportCenterOpen = ref(false)
const personalCenterOpen = ref(false)
const todoCenterOpen = ref(false)
const taskCenterOpen = ref(false)

const isUserCenterActive = computed(() => {
  return ['users', 'roles', 'organizations'].includes(props.currentTab)
})

const isAnnouncementCenterActive = computed(() => {
  return props.currentTab.startsWith('announcements')
})

const isPermissionCenterActive = computed(() => {
  return ['aaPermissions', 'baPermissions', 'laPermissions', 'daPermissions'].includes(props.currentTab)
})

const isDataCenterActive = computed(() => {
  return ['databaseManager', 'sqlExecution', 'logQuery'].includes(props.currentTab)
})

const isDevCenterActive = computed(() => {
  return ['processManagement', 'jobManagement', 'jobScheduled'].includes(props.currentTab)
})

const isManagementCenterActive = computed(() => {
  return ['taskManagement', 'moduleManagement', 'systemManagement', 'companyManagement', 'tenantManagement'].includes(props.currentTab)
})

const isReportCenterActive = computed(() => {
  return ['systemReports', 'customReports', 'reportManagement'].includes(props.currentTab)
})

const isPersonalCenterActive = computed(() => {
  return ['personalInfo', 'passwordChange', 'proxySettings'].includes(props.currentTab)
})

const isTodoCenterActive = computed(() => {
  return ['pendingTasks', 'launchableProcesses', 'drafts'].includes(props.currentTab)
})

const isTaskCenterActive = computed(() => {
  return ['completedTasks', 'viewableTasks', 'submittedTasks', 'ccTasks'].includes(props.currentTab)
})

const closeAllSubmenus = () => {
  userCenterOpen.value = false
  announcementCenterOpen.value = false
  permissionCenterOpen.value = false
  dataCenterOpen.value = false
  devCenterOpen.value = false
  managementCenterOpen.value = false
  reportCenterOpen.value = false
  personalCenterOpen.value = false
  todoCenterOpen.value = false
  taskCenterOpen.value = false
}

const toggleUserCenter = () => {
  const wasOpen = userCenterOpen.value
  closeAllSubmenus()
  userCenterOpen.value = !wasOpen
}

const toggleAnnouncementCenter = () => {
  const wasOpen = announcementCenterOpen.value
  closeAllSubmenus()
  announcementCenterOpen.value = !wasOpen
}

const togglePermissionCenter = () => {
  const wasOpen = permissionCenterOpen.value
  closeAllSubmenus()
  permissionCenterOpen.value = !wasOpen
}

const toggleDataCenter = () => {
  const wasOpen = dataCenterOpen.value
  closeAllSubmenus()
  dataCenterOpen.value = !wasOpen
}

const toggleDevCenter = () => {
  const wasOpen = devCenterOpen.value
  closeAllSubmenus()
  devCenterOpen.value = !wasOpen
}

const toggleManagementCenter = () => {
  const wasOpen = managementCenterOpen.value
  closeAllSubmenus()
  managementCenterOpen.value = !wasOpen
}

const toggleReportCenter = () => {
  const wasOpen = reportCenterOpen.value
  closeAllSubmenus()
  reportCenterOpen.value = !wasOpen
}

const togglePersonalCenter = () => {
  const wasOpen = personalCenterOpen.value
  closeAllSubmenus()
  personalCenterOpen.value = !wasOpen
}

const toggleTodoCenter = () => {
  const wasOpen = todoCenterOpen.value
  closeAllSubmenus()
  todoCenterOpen.value = !wasOpen
}

const toggleTaskCenter = () => {
  const wasOpen = taskCenterOpen.value
  closeAllSubmenus()
  taskCenterOpen.value = !wasOpen
}

const toggleSidebar = () => {
  const sidebar = document.querySelector('.sidebar')
  if (sidebar) {
    sidebar.classList.toggle('collapsed')
  }
  const wrapper = document.querySelector('#wrapper')
  if (wrapper) {
    wrapper.classList.toggle('collapsed')
  }
}
</script>

<style scoped>
.sidebar {
  width: 220px;
  min-height: 100vh;
  position: fixed;
  top: 0;
  left: 60px;
  z-index: 1000;
  background-color: #2f4050;
  transition: width 0.3s ease;
  overflow-y: auto;
  overflow-x: visible;
}

.sidebar.collapsed {
  width: 50px;
}

.sidebar-header {
  padding: 12px;
  background-color: #1f2d3d;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.logo-area {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.logo-text {
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.company-info {
  display: flex;
  flex-direction: column;
}

.company-name {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.sidebar.collapsed .company-info {
  display: none;
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  position: relative;
}

.menu-item button {
  width: 100%;
  padding: 12px 15px 12px 20px;
  background: none;
  border: none;
  color: #a7b1c2;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.menu-item button:hover {
  background-color: #293846;
  color: #fff;
}

.menu-item.active > button {
  background-color: #293846;
  color: #fff;
  border-left: 3px solid #1ab394;
}

.menu-item button i {
  width: 18px;
  margin-right: 10px;
  text-align: center;
}

.menu-item button .arrow {
  margin-left: auto;
  font-size: 12px;
}

.menu-item.open button .arrow {
  transform: rotate(180deg);
}

.submenu {
  list-style: none;
  padding: 5px 0;
  margin: 5px 10px;
  width: calc(100% - 20px);
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.submenu li button {
  padding: 8px 15px 8px 20px;
  font-size: 12px;
  color: #333;
  text-align: left;
  background-color: #fff;
}

.submenu li button:hover {
  background-color: #f5f5f5;
  color: #1ab394;
}

.submenu li button:active {
  background-color: #fff;
  color: #333;
}

.submenu li button.active {
  background-color: #fff;
  color: #1ab394;
  font-weight: 500;
}

.sidebar-toggle {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-size: 12px;
  transition: background-color 0.2s ease;
}

.sidebar-toggle:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.sidebar.collapsed .sidebar-header {
  padding: 10px;
}

.sidebar.collapsed .logo-circle {
  width: 30px;
  height: 30px;
}

.sidebar.collapsed .logo-text {
  font-size: 10px;
}

.sidebar.collapsed .menu-item button span {
  display: none;
}

.sidebar.collapsed .menu-item button .arrow {
  display: none;
}

.sidebar.collapsed .menu-item.active > button {
  border-left: none;
}

.sidebar.collapsed .submenu {
  position: absolute;
  left: 50px;
  top: 0;
  min-width: 150px;
  display: none;
}

.sidebar.collapsed .menu-item:hover .submenu {
  display: block;
}

.sidebar.collapsed .sidebar-toggle i {
  transform: rotate(180deg);
}
</style>
